// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-1cb47ce2]{cursor:pointer;width:360px;height:50px;background:linear-gradient(315deg,#ff846d,#ff3973);border-radius:4px;color:#fff;font-size:16px;line-height:25px;margin:0 auto;padding:13px 0 12px;text-align:center}.btn.disabled[data-v-1cb47ce2]{background:#d4d4d4;cursor:default}", ""]);
// Exports
module.exports = exports;
